import React, { useEffect, useRef, useState, useImperativeHandle } from 'react';
import { isMobileFun, getQueryString } from '../../utils/obj-utils';
import './style.scss';
import temp from '../../temp/config';
import { dataFetcher } from '../../dataFetcher';
import { event } from 'jquery';

export default function index({ fields }) {
  const isMobile = isMobileFun();
  const gwOwncenter = `${temp.app.mall}gwOwn/center`;
  const gwOwnlogin = `${temp.app.mall}gwOwn/login`;
  useEffect(() => {
    if (getQueryString('MembermobileValue')) {
      // url带参
      getMembermobileValue(getQueryString('MembermobileValue'));
    }
    document.getElementById('centerIframe').onload = function () {
      setTimeout(function () {
        document.getElementById('centerIframe').contentWindow.postMessage(
          {
            source: 2
          },
          gwOwnlogin
        );
      }, 500);
    };
    if (window.attachEvent) {
      window.attachEvent('message', function (event) {
        membermessageCenter(event);
      });
    } else if (window.addEventListener) {
      window.addEventListener('message', function (event) {
        membermessageCenter(event);
      });
    }
  }, []);
  var eventJson;
  function membermessageCenter(event) {
    if (event.data && event.data?.landed !== undefined) {
      eventJson = event.data;
      var val = document.querySelector('.userName');
      eventJson = event.data;
      if (event.data.landed) {
        document.getElementById('centerIframe').setAttribute('src', gwOwncenter);
        if (isMobile) {
          document.getElementById('centerIframe').setAttribute('height', document.documentElement.clientHeight + 200);
        } else {
          if (event.data.isDwpMember) {
            document.getElementById('centerIframe').setAttribute('height', '1900');
          } else {
            document.getElementById('centerIframe').setAttribute('height', '1200');
          }
        }
        val.innerHTML = event.data.nickName;
        val.classList.add('redUserName');
        if (event.data.mobile) {
          //登录或者注册
          if (event.data.action && (event.data.action === 'login' || event.data.action === 'regist')) {
            getMembermobileValue(event.data.mobile);
          }
        }
      } else {
        document.getElementById('centerIframe').setAttribute('src', gwOwnlogin);
        if (isMobile) {
          document.getElementById('centerIframe').style.height = '100vh';
        } else {
          document.getElementById('centerIframe').setAttribute('height', '550px');
        }
        val.classList.remove('redUserName');
        val.innerHTML = '请登录';
        sessionStorage.removeItem('MemberCarInfo');
        sessionStorage.removeItem('MembermobileValue');
      }
    } else {
      document.getElementById('centerIframe').setAttribute('src', gwOwnlogin);
      if (isMobile) {
        document.getElementById('centerIframe').style.height = '100vh';
      } else {
        document.getElementById('centerIframe').setAttribute('height', '550px');
      }
      sessionStorage.removeItem('MemberCarInfo');
      sessionStorage.removeItem('MembermobileValue');
      val.classList.remove('redUserName');
      val.innerHTML = '请登录';
    }
    if (event.data.backHome !== undefined && event.data.backHome) {
      //退出登录
      document.getElementById('centerIframe').setAttribute('src', gwOwnlogin);
      backUrl(false, '-1');
    }
  }
  function getMembermobileValue(mobile) {
    if (mobile) {
      sessionStorage.removeItem('MemberCarInfo');
      sessionStorage.setItem('MembermobileValue', mobile); // 手机号码存到session
      dataFetcher('/api/honda/v1/DMP/GetSafeUserTag?mobile=' + mobile)
        .then(({ data }) => {
          if (data.Status) {
            if (data?.Data?.retCode === 200 && data?.Data?.result.length > 0) {
              sessionStorage.setItem('MemberCarInfo', JSON.stringify(data?.Data?.result)); // 用户信息存到session
              backUrl(true, '-2');
            } else {
              backUrl(false, '-2');
            }
          } else {
            backUrl(false, '-2');
          }
        })
        .catch((error) => {
          backUrl(false, '-2');
        });
    }
  }
  // 用户中心以及登陆逻辑
  function backUrl(bool, page) {
    if (page == '-1') {
      window.location.href = '/';
    } else {
      var backurl = document.referrer;
      if (backurl && backurl.indexOf('www.ghac.cn') > -1) {
        if (bool) {
          window.location.href = '/member/home';
        } else {
          window.history.go(-1);
        }
      } else {
        window.location.href = '/';
      }
    }
  }
  return (
    <div className="centerBox">
      <iframe
        id="centerIframe"
        className="centerIframe"
        src=""
        width="100%"
        height="100%"
        frameBorder="0"
        scrolling="no"
        // sandbox="allow-same-origin allow-scripts"
      />
    </div>
  );
}
